import * as React from 'react';

import progress0pct from '../../assets/progress0pctM.jpg';
import progress33pct from '../../assets/progress33pctM.jpg';
import progress66pct from '../../assets/progress66pctM.jpg'; 

import PropTypes from 'prop-types';

/** 
 * 3-4 step registration progress indicator
 **/
const ProgressJoint = ({
  currentStep=0
}) => {

  const imgStyle = { 
    width: '480px',
    maxWidth: '100%',
    display: 'block',
    margin: '5rem auto 2rem'
  };

  let progressImage;
  let progressText;
  switch(currentStep) {
    case 1:
      progressImage = progress33pct;
      progressText = "33";
      break;    
    case 2:
      progressImage = progress66pct;
      progressText = "66";
      break;
    default:
      progressImage = progress0pct;
      progressText = "0";
  }

  return (
    <img style={imgStyle} src={progressImage} alt={`${progressText} percent complete`} />
  );
};

ProgressJoint.propTypes = {
  currentStep: PropTypes.number
};

export default ProgressJoint;